export default __webpack_public_path__ + "media/zurb/img/growth-design/funnels-graph-53c41b550be26ce071e9afbf886f46be.png";